import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

import { completionChoices, portRequestChoice } from '../walkthroughSteps';

const DESCRIPTIONS = {
  home: 'Go straight to Home, or start with a short guided tutorial.',
  tutorial: 'We will open Learn Medsender when you land, so you can walk through the basics step by step.',
  port_request: 'We will open Admin → Port Requests so you can move the fax numbers you already have to Medsender. '
    + 'Have your account number and port-out PIN from your current carrier ready; a recent bill helps too, if you have one. '
    + 'It takes about 10 minutes; the move itself usually takes a few days to a few weeks.',
};

/**
 * The final step: where to land once setup is done.
 *
 * The answer is persisted as `users.walkthrough_start_destination` and read back
 * by `shouldAutoOpenTutorialMenu`, which is what actually decides whether the
 * Learn Medsender checklist opens. Both choices navigate to `/app` — the
 * tutorial is an overlay, not a route. Admins who can port numbers also get
 * "Start a port request" (ENG-3103), which saves Home and opens /admin.
 */
const StartStep = ({ launchDestination, onSelect, canRequestNumberPort }) => {
  const choices = canRequestNumberPort ? [...completionChoices, portRequestChoice] : completionChoices;
  const selected = choices.some((choice) => choice.key === launchDestination) ? launchDestination : 'home';
  return (
    <div className="walkthrough-compact-step walkthrough-start-step">
      <h2>What would you like to do first?</h2>
      <p>{DESCRIPTIONS[selected]}</p>
      <Radio.Group value={launchDestination} onChange={onSelect}>
        {choices.map((choice) => <Radio key={choice.key} value={choice.key}>{choice.label}</Radio>)}
      </Radio.Group>
      {canRequestNumberPort && (
        <p className="walkthrough-help-text">You can always find this later in Admin → Port Requests.</p>
      )}
    </div>
  );
};

StartStep.defaultProps = {
  launchDestination: 'home',
  canRequestNumberPort: false,
};

StartStep.propTypes = {
  launchDestination: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  canRequestNumberPort: PropTypes.bool,
};

export default StartStep;
